import { useClient } from './useClient';
import { queryStringifyObject } from '../Utils';

export interface FeatureFlagRequest {
    category: string;
}

export interface FeatureFlagResponse {
    id: number;
    category: string;
    description: string | null;
    value: string | null;
    is_active: boolean;
}

export const useIndividualFeatureFlag = ({ category }: FeatureFlagRequest) =>
    useClient<FeatureFlagResponse>({ url: `api/feature-flag/flag-by-category?${queryStringifyObject({ category })}` });
